import React from 'react';
import { useState, useEffect } from 'react';
import { Typography, IconButton } from '@mui/material'; // Make sure to import necessary components

// Custom hook to manage and track online status
const useCheckUserIsOnline = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleStatusChange = () => {
			setIsOnline(navigator.onLine);
		};

		window.addEventListener('online', handleStatusChange);
		window.addEventListener('offline', handleStatusChange);

		// Clean up
		return () => {
			window.removeEventListener('online', handleStatusChange);
			window.removeEventListener('offline', handleStatusChange);
		};
	}, []);

	// const Alert = !isOnline ? (
	// 	<div
	// 		style={{
	// 			width: '736px',
	// 			border: '1px solid #FFA726',
	// 			backgroundColor: '#FFF4E5',
	// 			padding: '8px',
	// 			display: 'flex',
	// 			alignItems: 'center',
	// 			justifyContent: 'space-between',
	// 			marginBottom: '10px',
	// 			marginTop: '10px',
	// 			marginRight: '20px',
	// 		}}
	// 	>
	// 		<div style={{ display: 'flex', alignItems: 'center' }}>
	// 			<img
	// 				src="/assets/icons/Wifi-orange.svg"
	// 				alt="Offline"
	// 				style={{ marginRight: '10px' }}
	// 			/>
	// 			<Typography
	// 				variant="body1"
	// 				color="#66491F"
	// 				className="!font-jost"
	// 			>
	// 				You're currently offline. Please reconnect to make changes.
	// 			</Typography>
	// 		</div>
	// 		<IconButton sx={{ p: 0, mr: '5px', mt: '2px' }}>
	// 			<img
	// 				src="/assets/icons/Close.svg"
	// 				alt="Remove"
	// 				className="w-5 h-5 md:block hidden"
	// 			/>
	// 		</IconButton>
	// 	</div>
	// ) : null;

	// return { isOnline, Alert };
  return { isOnline };
};

export default useCheckUserIsOnline;
